import { Grid } from "@mui/material";
import {
  BtnClear,
  BtnSearch,
} from "components/Button/ButtonAll";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import { MultipleSelectItem } from "components/Input/Select/MultipleSelectItem";
import moment from "moment";
import { useState, useEffect } from "react";
import { FnAxios } from "utilities/utilities";

const FilterReport = ({ onSearch, onClear, onPreview }) => {
  const AxiosFn = FnAxios();
  const [arrYear, setArrYear] = useState([]);
  const [nMin, setNMin] = useState(null);
  const [nMax, setNMax] = useState(null);

  useEffect(() => {
    AxiosFn.Get(`FundActionPlan/GetFilterFundActionPlan`, {}, (result) => {
      setArrYear([...result.objResult.lstYear]);
    });
  }, [])

  return (
    <Grid item xs={12}>
      <Grid container spacing={1}>
        <Grid item xs={6} md={3}>
          <MultipleSelectItem
            id="sYear"
            name="sYear"
            label="ประจำปีบัญชี"
            options={arrYear}
            required={false}
            disabled={false}
            limitTag={2}
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <MultipleSelectItem
            id="sQuarter"
            name="sQuarter"
            label="ไตรมาส"
            options={[
              { value: "1", label: "1" },
              { value: "2", label: "2" },
              { value: "3", label: "3" },
              { value: "4", label: "4" }
            ]}
            required={false}
            disabled={false}
          />
        </Grid>
        <Grid item xs={12} md={2.8}>
          <DatePickerItem
            name="sResultDateStart"
            label="วันที่บันทึกผลเริ่มต้น"
            required={false}
            maxDate={nMax}
            onChange={(e) => {
              if (e) {
                setNMin(e)
              } else {
                setNMin(null)
              }
            }}
          />
        </Grid>
        <Grid item xs={0.4} sx={{display:"flex",justifyContent:"center",alignItems : "center"}}>-</Grid>
        <Grid item xs={12} md={2.8}>
          <DatePickerItem
            name="sResultDateEnd"
            label="วันที่บันทึกผลสิ้นสุด"
            required={false}
            minDate={nMin}
            onChange={(e) => {
              if (e) {
                setNMax(e)
              } else {
                setNMax(null)
              }
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={1} display={"flex"} justifyContent={"flex-end"}>
            <Grid item xs={3}>
              <MultipleSelectItem
                id="sStatus"
                name="sStatus"
                label="สถานะ"
                options={[
                  { value: "0", label: "รอรายงานผล" },
                  { value: "1", label: "รอตรวจสอบ" },
                  { value: "2", label: "ตรวจสอบแล้ว" }
                ]}
                required={false}
                disabled={false}
                limitTag={1}
              />
            </Grid>
            <Grid item xs={12} md={1}
              sx={{
                alignSelf: "center",
                display: "flex",
                justifyContent: "space-around",
              }}
            >
              <Grid item sx={{ mr: 0.5 }}>
                <BtnClear
                  id={"btnClearSearchAll"}
                  IsCircleWithOutText={true}
                  onClick={onClear}
                />
              </Grid>
              <Grid item>
                <BtnSearch
                  id={"btnSearchAll"}
                  IsCircleWithOutText={true}
                  onClick={onSearch}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FilterReport;
